export default __webpack_public_path__ + "static/media/2005.2722097f.png";